let _ = t => t,
  _t;
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';

//@ts-expect-error missing type
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { getHubletAppUrl } from '../utils/urls';
import Logger from '../lib/Logger';
import { getHublet } from '../store/app/selectors';
import { useTracker } from '../tracking/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOG = Logger.getLogger('FreeCRMModalIframe');

/* 2147483642 is the highest value of z-index.
Signup page chat bubble also has the same value. We want to show this modal over the chat.
Because this demo renders after it, having the same z-index puts it over the chat.
*/

const FullHeightIframeModalStyle = createGlobalStyle(_t || (_t = _`
  .uiOverlay-backdrop {
    z-index: 2147483647 !important;
  }

  .demo-tour-iframe-dialog .uiDialogBody {
    padding: 0;
    & > div {
      height: 100%;
    }
}
`));
const FreeCRMModalIframe = ({
  onClose
}) => {
  const Tracker = useTracker();
  const hublet = useSelector(getHublet);
  const freeCrmDemoUrl = '/presignup-crm-free-demo/free-crm?via=signup-survey';
  const handleMessageFromIframe = message => {
    const {
      type,
      tour,
      step
    } = message.payload;
    if (type !== 'FREE_CRM_DEMO_TOUR_STEP_VIEW') {
      LOG.warn('Unrecognised iframe message received', {
        extra: {
          message
        }
      });
      return;
    }
    Tracker.signupInteraction('demo-tour-iframe-view-step', {
      tour,
      step
    });
  };
  const handleEscapePress = useCallback(({
    key
  }) => {
    // This is useful for both users and allowing unit tests to not have to interact
    // with iframe/external content
    if (key === 'Escape') {
      Tracker.signupInteraction('demo-tour-iframe-leave', {
        via: 'escape-key'
      });
      onClose();
    }
  }, [onClose, Tracker]);
  useEffect(() => {
    document.addEventListener('keydown', handleEscapePress, false);
    return () => document.removeEventListener('keydown', handleEscapePress, false);
  }, [handleEscapePress]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "free-crm-modal-iframe",
    children: [/*#__PURE__*/_jsx(UIModalIFrame, {
      appName: "signup-ui-lego",
      dialogClassName: "demo-tour-iframe-dialog",
      height: "100%",
      iframePassthruProps: {
        // props that are passed directly to the iframe
        id: 'free-crm-demo-iframe',
        name: 'free-crm-demo-iframe'
      },
      readyTimeout: 2000,
      src: `${getHubletAppUrl(hublet)}${freeCrmDemoUrl}`,
      use: "fullscreen",
      width: "100%",
      onClose: ({
        via
      }) => {
        Tracker.signupInteraction('demo-tour-iframe-leave', {
          via
        });
        onClose();
      },
      onInitError: errorCode => {
        LOG.error('Sync Error occurred', {
          extra: {
            errorCode
          }
        });
        Tracker.signupInteraction('demo-tour-iframe-error', {
          errorType: 'sync',
          errorCode
        });
        onClose();
      },
      onMessage: handleMessageFromIframe,
      onReady: () => Tracker.signupInteraction('demo-tour-iframe-view'),
      onReadyError: errorCode => {
        LOG.error('Ready Error occurred', {
          extra: {
            errorCode
          }
        });
        Tracker.signupInteraction('demo-tour-iframe-error', {
          errorType: 'iframe-not-ready',
          errorCode
        });
        onClose();
      }
    }), /*#__PURE__*/_jsx(FullHeightIframeModalStyle, {})]
  });
};
export default FreeCRMModalIframe;